module.exports = __webpack_public_path__ + "static/008573-58af27aad3447233533398002dd08a79.jpg";